export default "/_next/static/images/2a6aba0d269214e0fc08b14ba8c71e14.jpg";